(function () {
  'use strict';

  function activePreorderButton(form) {
    form = form || document.querySelector('[data-pdp-v2-product-form]');
    if (!form) return null;
    return Array.prototype.find.call(form.querySelectorAll('.timesact-preOrder-button, .timesact-preorder-button'), function (button) {
      return !button.disabled && window.getComputedStyle(button).display !== 'none';
    }) || null;
  }

  function syncPreorderControls(form) {
    var preorder = activePreorderButton(form) || form.dataset.ptPreorderPlan;
    // Timesact sets inline !important styles; keep the shared pill shape after injection.
    function importantStyle(node, property, value) {
      if (node && (node.style.getPropertyValue(property) !== value || node.style.getPropertyPriority(property) !== 'important')) {
        node.style.setProperty(property, value, 'important');
      }
    }
    var dated = form.querySelector('.pdp-v2-purchase--dated-preorder');
    if (dated) {
      var primary = dated.querySelector('[data-pdp-v2-submit]');
      importantStyle(primary, 'border-radius', '0px 999px 999px 0px');
      importantStyle(primary, 'font-size', '14px');
      importantStyle(primary, 'height', '56px');
      importantStyle(primary, 'padding', '8px 12px');
    }
    var notify = form.querySelector('.timesact-backInStock-button');
    importantStyle(notify, 'border-radius', '999px');
    if (notify && notify.textContent.trim() !== 'Notify me') notify.textContent = 'Notify me';
    if (notify && preorder) {
      importantStyle(notify, 'background-color', 'transparent');
      importantStyle(notify, 'color', '#2f6b4f');
      importantStyle(notify, 'border', '1px solid #2f6b4f');
      importantStyle(notify, 'font-size', '14px');
      importantStyle(notify, 'height', '44px');
      importantStyle(notify, 'padding', '8px 16px');
    }

    var actions = document.querySelectorAll('[data-pdp-v2-price-action], .pdp-v2-final .pdp-v2-action');
    actions.forEach(function (action) {
      var wasPreorder = action.dataset.pdpV2PreorderActive === 'true';
      action.dataset.pdpV2PreorderActive = String(!!preorder);
      if (preorder) {
        if (action.getAttribute('aria-busy') !== 'true') writeActionLabel(action, (document.querySelector('[data-pt-preorder-label]') || {}).dataset?.ptPreorderLabel || 'Preorder');
      } else if (wasPreorder) {
        updatePurchaseTotal(action, readQuantity(form.querySelector('[data-pdp-v2-quantity]')));
      }
    });
  }

  function refreshCartHeader() {
    if (window.ptRefreshCartHeader) return window.ptRefreshCartHeader();
    return fetch('/cart', { credentials: 'same-origin' })
      .then(function (response) { return response.text(); })
      .then(function (markup) {
        var parsed = new DOMParser().parseFromString(markup, 'text/html');
        var source = parsed.querySelector('.header_user_cart');
        var destination = document.querySelector('.header_user_cart');
        if (source && destination) destination.innerHTML = source.innerHTML;
      });
  }

  function formatPurchaseTotal(cents, action) {
    var currency = action.dataset.pdpV2Currency || (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'USD';
    var locale = document.documentElement.lang || 'en-US';
    try {
      return new Intl.NumberFormat(locale, {
        style: 'currency',
        currency: currency,
        currencyDisplay: 'narrowSymbol'
      }).format(cents / 100);
    } catch (error) {
      return (cents / 100).toFixed(2);
    }
  }

  function updatePurchaseTotal(action, quantity) {
    if (!action || !action.dataset.pdpV2UnitPrice) return;
    if (activePreorderButton() || document.querySelector('[data-pt-preorder-plan]:not([data-pt-preorder-plan=""])')) {
      if (action.getAttribute('aria-busy') !== 'true') writeActionLabel(action, (document.querySelector('[data-pt-preorder-label]') || {}).dataset?.ptPreorderLabel || 'Preorder');
      return;
    }
    if (action.dataset.pdpV2Available === 'false') {
      writeActionLabel(action, action.dataset.defaultLabel || 'Sold out');
      return;
    }
    var form = document.querySelector('[data-pdp-v2-product-form]');
    var pricingNode = form && form.querySelector('[data-pdp-v2-pricing]');
    var unitPrice = Number(action.dataset.pdpV2UnitPrice);
    var addonPrice = 0;
    var plan = null;
    var selectedPlan = '';
    if (pricingNode) {
      try {
        var pricing = JSON.parse(pricingNode.textContent);
        var values = new FormData(form);
        var variant = pricing.variants.find(function (entry) { return String(entry.id) === String(values.get('id')); });
        selectedPlan = values.get('selling_plan') || '';
        if (variant) {
          plan = variant.plans.find(function (entry) { return String(entry.id) === String(selectedPlan); });
          unitPrice = plan ? plan.price : variant.price;
        }
        if (selectedPlan && !plan) {
          var fallbackLabel = action.dataset.pdpV2ActionLabel || 'Add to cart';
          action.dataset.defaultLabel = fallbackLabel;
          if (action.getAttribute('aria-busy') !== 'true') writeActionLabel(action, fallbackLabel);
          var uncertainTotal = form.querySelector('[data-pdp-v2-total-note]');
          if (uncertainTotal) uncertainTotal.hidden = true;
          var uncertainPlan = form.querySelector('[data-pdp-v2-plan-note]');
          if (uncertainPlan) uncertainPlan.hidden = true;
          return;
        }
        var addon = form.querySelector('[data-pdp-v2-addon]');
        if (addon && addon.checked && !addon.disabled) addonPrice = Number(addon.dataset.price) || 0;
      } catch (error) { return; }
    }
    var total = unitPrice * Math.max(1, Number(quantity) || 1) + addonPrice;
    if (form && form.querySelector('[data-pdp-v2-bar-offer]') && !selectedPlan && Number(quantity) === 3 && unitPrice === 1499) total = 4000 + addonPrice;
    if (form) form.querySelectorAll('[data-pdp-v2-bar-quantity]').forEach(function (option) {
      option.setAttribute('aria-pressed', String(!selectedPlan && Number(option.dataset.pdpV2BarQuantity) === Number(quantity)));
    });
    var label = (action.dataset.pdpV2ActionLabel || 'Add to cart') + ' · ' + formatPurchaseTotal(total, action);
    action.dataset.defaultLabel = label;
    if (action.getAttribute('aria-busy') !== 'true') writeActionLabel(action, label);
    if (form) {
      var totalNote = form.querySelector('[data-pdp-v2-total-note]');
      if (totalNote) {
        totalNote.hidden = !addonPrice;
        var totalText = totalNote.dataset.label + ' ' + formatPurchaseTotal(total, action);
        if (totalNote.textContent !== totalText) totalNote.textContent = totalText;
      }
      var planNote = form.querySelector('[data-pdp-v2-plan-note]');
      if (planNote) {
        planNote.hidden = !plan;
        if (plan) {
          var planText = plan.name;
          if (plan.adjustments && plan.adjustments.length) {
            var first = plan.adjustments[0];
            var firstPrice = formatPurchaseTotal(first.price, action);
            if (first.orders && plan.adjustments.length > 1) {
              planText += ' · ' + planNote.dataset.initial.replace('__COUNT__', first.orders).replace('__PRICE__', firstPrice);
              planText += ' ' + planNote.dataset.later.replace('__PRICE__', formatPurchaseTotal(plan.adjustments[1].price, action));
            } else if (!first.orders) {
              planText += ' · ' + planNote.dataset.each.replace('__PRICE__', firstPrice);
            }
          }
          if (planNote.textContent !== planText) planNote.textContent = planText;
        }
      }
    }
  }

  function writeActionLabel(action, label) {
    var text = action.querySelector('[data-submit-button-text]');
    var target = text || action;
    if (target.textContent !== label) target.textContent = label;
  }

  function setPurchaseStatus(message, state) {
    document.querySelectorAll('[data-pdp-v2-price-action]').forEach(function (action) {
      writeActionLabel(action, message);
      action.classList.toggle('is-added', state === 'added');
      action.classList.toggle('is-adding', state === 'adding');
      if (state === 'adding') action.setAttribute('aria-busy', 'true');
      else action.removeAttribute('aria-busy');
    });
  }

  function resetPurchaseStatus() {
    document.querySelectorAll('[data-pdp-v2-price-action]').forEach(function (action) {
      action.classList.remove('is-added', 'is-adding');
      action.removeAttribute('aria-busy');
      writeActionLabel(action, action.dataset.defaultLabel || 'Add to cart');
    });
  }

  function minimumPurchaseQuantity() {
    var form = document.querySelector('[data-pdp-v2-product-form]');
    return form && String(new FormData(form).get('selling_plan')) === '3984883871' ? 3 : 1;
  }

  function readQuantity(input) {
    if (!input) return 1;
    return Math.max(minimumPurchaseQuantity(), Number(input.dataset.pdpV2QuantityValue || input.value) || 1);
  }

  function writeQuantity(input, quantity) {
    var safeQuantity = Math.max(minimumPurchaseQuantity(), Number(quantity) || 1);
    if (!input) return safeQuantity;
    input.value = safeQuantity;
    input.dataset.pdpV2QuantityValue = safeQuantity;
    input.setAttribute('value', safeQuantity);
    return safeQuantity;
  }

  function syncAllPurchaseControls(quantity) {
    var safeQuantity = Math.max(minimumPurchaseQuantity(), Number(quantity) || 1);
    document.querySelectorAll('[data-pdp-v2-quantity]').forEach(function (input) {
      writeQuantity(input, safeQuantity);
    });
    document.querySelectorAll('[data-pdp-v2-quantity-display]').forEach(function (display) {
      display.textContent = safeQuantity;
    });
    document.querySelectorAll('[data-pdp-v2-price-action]').forEach(function (action) {
      updatePurchaseTotal(action, safeQuantity);
    });
  }

  function initGallery(gallery) {
    var stage = gallery.querySelector('[data-pdp-v2-gallery-stage]');
    var slides = Array.prototype.slice.call(gallery.querySelectorAll('[data-pdp-v2-slide]'));
    var thumbNav = gallery.querySelector('[data-pdp-v2-thumb-nav]');
    var thumbRail = gallery.querySelector('[data-pdp-v2-thumbs]');
    var thumbs = Array.prototype.slice.call(gallery.querySelectorAll('[data-pdp-v2-thumb]'));
    var thumbsPrevious = gallery.querySelector('[data-pdp-v2-thumbs-previous]');
    var thumbsNext = gallery.querySelector('[data-pdp-v2-thumbs-next]');
    var dots = Array.prototype.slice.call(gallery.querySelectorAll('[data-pdp-v2-dot]'));
    var openers = Array.prototype.slice.call(gallery.querySelectorAll('[data-pdp-v2-gallery-open]'));
    var galleryPrevious = gallery.querySelector('[data-pdp-v2-gallery-previous]');
    var galleryNext = gallery.querySelector('[data-pdp-v2-gallery-next]');
    var lightbox = gallery.querySelector('[data-pdp-v2-lightbox]');
    var activeIndex = 0;
    if (!stage || !slides.length) return;

    function updateThumbControls() {
      if (!thumbNav || !thumbRail) return;
      var hasOverflow = thumbRail.scrollHeight > thumbRail.clientHeight + 2;
      thumbNav.classList.toggle('has-overflow', hasOverflow);
      if (thumbsPrevious) thumbsPrevious.disabled = !hasOverflow || thumbRail.scrollTop <= 2;
      if (thumbsNext) thumbsNext.disabled = !hasOverflow || thumbRail.scrollTop + thumbRail.clientHeight >= thumbRail.scrollHeight - 2;
    }

    function keepActiveThumbVisible(index) {
      if (!thumbRail) return;
      var thumb = thumbs[index];
      if (!thumb) return;
      if (window.matchMedia('(max-width: 640px)').matches) {
        var left = thumb.offsetLeft;
        var right = left + thumb.offsetWidth;
        if (left < thumbRail.scrollLeft) thumbRail.scrollTo({ left: left, behavior: 'smooth' });
        else if (right > thumbRail.scrollLeft + thumbRail.clientWidth) {
          thumbRail.scrollTo({ left: right - thumbRail.clientWidth, behavior: 'smooth' });
        }
        return;
      }
      var railRect = thumbRail.getBoundingClientRect();
      var thumbRect = thumb.getBoundingClientRect();
      var top = thumbRect.top - railRect.top + thumbRail.scrollTop;
      var bottom = top + thumbRect.height;
      if (top < thumbRail.scrollTop) thumbRail.scrollTo({ top: top, behavior: 'smooth' });
      else if (bottom > thumbRail.scrollTop + thumbRail.clientHeight) {
        thumbRail.scrollTo({ top: bottom - thumbRail.clientHeight, behavior: 'smooth' });
      }
    }

    function scrollThumbRail(direction) {
      if (!thumbRail) return;
      var distance = Math.max(82, Math.floor(thumbRail.clientHeight * 0.72));
      thumbRail.scrollBy({ top: direction * distance, behavior: 'smooth' });
    }

    function setActive(index, moveStage) {
      index = (index + slides.length) % slides.length;
      activeIndex = index;
      slides.forEach(function (slide, itemIndex) { slide.classList.toggle('is-active', itemIndex === index); });
      thumbs.forEach(function (thumb, itemIndex) {
        if (itemIndex === index) thumb.setAttribute('aria-current', 'true');
        else thumb.removeAttribute('aria-current');
      });
      dots.forEach(function (dot, itemIndex) {
        if (itemIndex === index) dot.setAttribute('aria-current', 'true');
        else dot.removeAttribute('aria-current');
      });
      keepActiveThumbVisible(index);
      if (moveStage && window.matchMedia('(max-width: 640px)').matches) {
        stage.scrollTo({ left: index * stage.clientWidth, behavior: 'smooth' });
      }
    }

    thumbs.forEach(function (thumb, index) { thumb.addEventListener('click', function () { setActive(index, false); }); });
    dots.forEach(function (dot, index) { dot.addEventListener('click', function () { setActive(index, true); }); });
    if (galleryPrevious) galleryPrevious.addEventListener('click', function () { setActive(activeIndex - 1, true); });
    if (galleryNext) galleryNext.addEventListener('click', function () { setActive(activeIndex + 1, true); });
    if (thumbsPrevious) thumbsPrevious.addEventListener('click', function () { scrollThumbRail(-1); });
    if (thumbsNext) thumbsNext.addEventListener('click', function () { scrollThumbRail(1); });
    if (thumbRail) thumbRail.addEventListener('scroll', updateThumbControls, { passive: true });
    window.addEventListener('resize', updateThumbControls, { passive: true });

    var touchStartX = 0;
    stage.addEventListener('touchstart', function (event) {
      touchStartX = event.changedTouches[0].clientX;
    }, { passive: true });
    stage.addEventListener('touchend', function (event) {
      if (!window.matchMedia('(max-width: 640px)').matches) return;
      var delta = event.changedTouches[0].clientX - touchStartX;
      if (Math.abs(delta) < 45) return;
      if (activeIndex === slides.length - 1 && delta < 0) setActive(0, true);
      if (activeIndex === 0 && delta > 0) setActive(slides.length - 1, true);
    }, { passive: true });

    if (lightbox && openers.length) {
      var lightboxImage = lightbox.querySelector('[data-pdp-v2-lightbox-image]');
      var lightboxCount = lightbox.querySelector('[data-pdp-v2-lightbox-count]');
      var close = lightbox.querySelector('[data-pdp-v2-lightbox-close]');
      var previous = lightbox.querySelector('[data-pdp-v2-lightbox-previous]');
      var next = lightbox.querySelector('[data-pdp-v2-lightbox-next]');
      var lightboxIndex = 0;

      function showLightboxImage(index) {
        lightboxIndex = (index + openers.length) % openers.length;
        var opener = openers[lightboxIndex];
        lightboxImage.src = opener.dataset.fullSrc;
        lightboxImage.alt = opener.dataset.fullAlt || '';
        lightboxCount.textContent = (lightboxIndex + 1) + ' / ' + openers.length;
      }

      function closeLightbox() {
        lightbox.close();
        document.documentElement.classList.remove('pdp-v2-lightbox-open');
      }

      openers.forEach(function (opener, index) {
        opener.addEventListener('click', function () {
          showLightboxImage(index);
          lightbox.showModal();
          document.documentElement.classList.add('pdp-v2-lightbox-open');
        });
      });
      close.addEventListener('click', closeLightbox);
      previous.addEventListener('click', function () { showLightboxImage(lightboxIndex - 1); });
      next.addEventListener('click', function () { showLightboxImage(lightboxIndex + 1); });
      lightbox.addEventListener('click', function (event) { if (event.target === lightbox) closeLightbox(); });
      lightbox.addEventListener('close', function () { document.documentElement.classList.remove('pdp-v2-lightbox-open'); });
      lightbox.addEventListener('keydown', function (event) {
        if (event.key === 'ArrowLeft') showLightboxImage(lightboxIndex - 1);
        if (event.key === 'ArrowRight') showLightboxImage(lightboxIndex + 1);
      });
    }

    var ticking = false;
    stage.addEventListener('scroll', function () {
      if (ticking || !window.matchMedia('(max-width: 860px)').matches) return;
      ticking = true;
      window.requestAnimationFrame(function () {
        setActive(Math.round(stage.scrollLeft / Math.max(stage.clientWidth, 1)), false);
        ticking = false;
      });
    }, { passive: true });

    setActive(0, false);
    window.requestAnimationFrame(function () {
      updateThumbControls();
      window.requestAnimationFrame(function () {
        if (thumbRail) thumbRail.scrollTop = 0;
        updateThumbControls();
      });
    });
  }

  function initQuantity(scope) {
    var input = scope.querySelector('[data-pdp-v2-quantity]');
    var display = scope.querySelector('[data-pdp-v2-quantity-display]');
    var action = scope.querySelector('[data-pdp-v2-price-action]');
    if (!input) return;
    function refreshTotal() {
      updatePurchaseTotal(action, readQuantity(input));
    }
    function setQuantity(value) {
      var safeQuantity = writeQuantity(input, value);
      if (display) display.textContent = safeQuantity;
      refreshTotal();
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }
    input.addEventListener('input', refreshTotal);
    input.addEventListener('change', refreshTotal);
    setQuantity(readQuantity(input));
  }

  function initQuantityControls() {
    function syncFromInput(event) {
      if (!event.target.matches('[data-pdp-v2-quantity]')) return;
      syncAllPurchaseControls(readQuantity(event.target));
    }

    document.addEventListener('input', syncFromInput, true);
    document.addEventListener('change', syncFromInput, true);

    document.addEventListener('click', function (event) {
      var control = event.target.closest('[data-pdp-v2-minus], [data-pdp-v2-plus]');
      if (!control) return;
      var purchase = control.closest('[data-pdp-v2-purchase]');
      var input = purchase && purchase.querySelector('[data-pdp-v2-quantity]');
      if (!input) return;
      event.preventDefault();
      var change = control.hasAttribute('data-pdp-v2-plus') ? 1 : -1;
      var nextQuantity = writeQuantity(input, readQuantity(input) + change);
      syncAllPurchaseControls(nextQuantity);
      input.dispatchEvent(new Event('input', { bubbles: true }));
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }, true);
  }

  function initProductForm(form) {
    form.querySelectorAll('[data-pdp-v2-bar-quantity]').forEach(function (option) {
      option.addEventListener('click', function () {
        var oneTime = form.querySelector('input[type="radio"][name="selling_plan"][value=""]');
        if (oneTime) oneTime.click();
        if (new FormData(form).get('selling_plan')) return;
        var quantity = Number(option.dataset.pdpV2BarQuantity);
        syncAllPurchaseControls(quantity);
        var input = form.querySelector('[data-pdp-v2-quantity]');
        if (input) input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });
    var submit = form.querySelector('[data-pdp-v2-submit]');
    var addon = form.closest('[data-pdp-v2-buy-box]');
    addon = addon && addon.querySelector('[data-pdp-v2-addon]');
    if (!submit) return;

    var subscriptionSlot = form.querySelector('[data-pdp-v2-subscription-slot]');
    var purchaseSignature = '';
    function refreshPurchaseSelection() {
      var values = new FormData(form);
      var quantityInput = form.querySelector('[data-pdp-v2-quantity]');
      var quantity = readQuantity(quantityInput);
      if (quantityInput && Number(quantityInput.value) !== quantity) syncAllPurchaseControls(quantity);
      var signature = [values.get('id'), values.get('selling_plan'), quantity, addon && addon.checked].join('|');
      if (signature === purchaseSignature) return;
      purchaseSignature = signature;
      document.querySelectorAll('[data-pdp-v2-price-action]').forEach(function (action) { updatePurchaseTotal(action, quantity); });
    }
    function placeSubscriptionWidget() {
      if (!subscriptionSlot) return;
      var widget = form.querySelector('.appstle_sub_widget');
      if (widget && widget.parentElement !== subscriptionSlot) subscriptionSlot.appendChild(widget);
      refreshPurchaseSelection();
      syncPreorderControls(form);
    }
    form.addEventListener('change', function () { window.setTimeout(refreshPurchaseSelection, 0); });
    placeSubscriptionWidget();
    if (subscriptionSlot && 'MutationObserver' in window) {
      var subscriptionObserver = new MutationObserver(placeSubscriptionWidget);
      subscriptionObserver.observe(form, { childList: true, subtree: true, attributes: true, attributeFilter: ['value', 'checked', 'selected', 'class', 'style', 'disabled'] });
    }

    form.addEventListener('submit', function (event) {
      if (form.dataset.ptPreorderPlan && !activePreorderButton(form)) { event.preventDefault(); return; }
      if (submit.disabled || form.querySelector('.timesact-backInStock-button, .timesact-preOrder-button, .timesact-preorder-button')) return;
      event.preventDefault();
      submit.disabled = true;
      setPurchaseStatus('Adding…', 'adding');
      var formData = new FormData(form);
      var quantityInput = form.querySelector('[data-pdp-v2-quantity]');
      var item = {
        id: Number(formData.get('id')),
        quantity: readQuantity(quantityInput)
      };
      var sellingPlan = formData.get('selling_plan');
      if (sellingPlan) item.selling_plan = Number(sellingPlan);
      var properties = {};
      formData.forEach(function (value, key) {
        var match = key.match(/^properties\[(.+)\]$/);
        if (match) properties[match[1]] = value;
      });
      if (Object.keys(properties).length) item.properties = properties;
      var items = [item];
      if (addon && addon.checked && addon.dataset.variantId) {
        items.push({ id: Number(addon.dataset.variantId), quantity: 1 });
      }

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: items })
      })
        .then(function (response) {
          if (!response.ok) return response.json().then(function (data) { throw new Error(data.description || 'Unable to add item'); });
          return response.json();
        })
        .then(function () {
          setPurchaseStatus('✓ Added to cart', 'added');
          document.dispatchEvent(new CustomEvent('cart:updated'));
          refreshCartHeader().catch(function () {});
          window.setTimeout(function () {
            submit.disabled = false;
            resetPurchaseStatus();
          }, 3200);
        })
        .catch(function (error) {
          setPurchaseStatus(error.message || 'Please try again', 'error');
          window.setTimeout(function () {
            submit.disabled = false;
            resetPurchaseStatus();
          }, 2200);
        });
    }, true);
  }

  function initSubstituteForm(container) {
    var submit = container.querySelector('[data-pdp-v2-substitute-submit]');
    var variantId = Number(container.dataset.variantId);
    if (!submit) return;

    submit.addEventListener('click', function () {
      if (submit.disabled || !variantId) return;

      var defaultLabel = submit.dataset.defaultLabel || submit.textContent;
      submit.disabled = true;
      submit.setAttribute('aria-busy', 'true');
      submit.textContent = 'Adding…';

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
      })
        .then(function (response) {
          if (!response.ok) return response.json().then(function (data) { throw new Error(data.description || 'Unable to add item'); });
          return response.json();
        })
        .then(function () {
          submit.textContent = submit.dataset.addedLabel || '✓ Added to cart';
          submit.classList.add('is-added');
          document.dispatchEvent(new CustomEvent('cart:updated'));
          refreshCartHeader().catch(function () {});
          window.setTimeout(function () {
            submit.disabled = false;
            submit.removeAttribute('aria-busy');
            submit.classList.remove('is-added');
            submit.textContent = defaultLabel;
          }, 3200);
        })
        .catch(function () {
          submit.textContent = submit.dataset.errorLabel || 'Please try again';
          window.setTimeout(function () {
            submit.disabled = false;
            submit.removeAttribute('aria-busy');
            submit.textContent = defaultLabel;
          }, 2200);
        });
    });
  }

  function initSticky(sticky) {
    var heroAction = document.querySelector('[data-pdp-v2-hero-atc]');
    var action = sticky.querySelector('[data-pdp-v2-sticky-action]');
    var heroQuantity = document.querySelector('[data-pdp-v2-product-form] [data-pdp-v2-quantity]');
    var stickyQuantity = sticky.querySelector('[data-pdp-v2-quantity]');
    if (!heroAction || !action) return;
    var heroForm = heroAction.closest('form') || heroAction.parentElement;

    var heroPassed = false;
    var footerVisible = false;
    function updateVisibility() {
      sticky.classList.toggle('is-visible', heroPassed && !footerVisible);
    }

    function refreshHeroPosition() {
      var candidates = heroForm.querySelectorAll('.timesact-preOrder-button, .timesact-preorder-button, .timesact-backInStock-button, [data-pdp-v2-hero-atc]');
      var target = Array.prototype.find.call(candidates, function (button) {
        var bounds = button.getBoundingClientRect();
        return bounds.width > 0 && bounds.height > 0 && window.getComputedStyle(button).visibility !== 'hidden';
      }) || heroForm;
      var rect = target.getBoundingClientRect();
      heroPassed = window.scrollY > 0 && rect.width > 0 && rect.height > 0 && rect.bottom <= 0;
      updateVisibility();
    }

    function findFooter() {
      return document.querySelector('#shopify-section-footer') || document.querySelector('.shopify-section-footer') || document.querySelector('body > footer');
    }

    function refreshFooterVisibility() {
      var footer = findFooter();
      if (!footer) {
        footerVisible = false;
      } else {
        var rect = footer.getBoundingClientRect();
        footerVisible = rect.top <= window.innerHeight + 96 && rect.bottom >= 0;
      }
      updateVisibility();
    }

    var heroObserver = new IntersectionObserver(function (entries) {
      refreshHeroPosition();
    }, { threshold: 0 });
    heroObserver.observe(heroForm);
    if ('ResizeObserver' in window) {
      new ResizeObserver(refreshHeroPosition).observe(heroForm);
    }
    new MutationObserver(refreshHeroPosition).observe(heroForm, {
      childList: true, subtree: true, attributes: true, attributeFilter: ['style', 'class', 'hidden']
    });

    var footer = findFooter();
    if (footer) {
      var footerObserver = new IntersectionObserver(function (entries) {
        footerVisible = entries[0].isIntersecting;
        updateVisibility();
      }, { threshold: 0, rootMargin: '0px 0px 96px 0px' });
      footerObserver.observe(footer);
    }
    function refreshStickyVisibility() {
      refreshHeroPosition();
      refreshFooterVisibility();
    }

    window.addEventListener('scroll', refreshStickyVisibility, { passive: true });
    window.addEventListener('resize', refreshStickyVisibility);
    window.requestAnimationFrame(refreshStickyVisibility);

    if (stickyQuantity && heroQuantity) {
      function syncStickyToHero() {
        writeQuantity(heroQuantity, readQuantity(stickyQuantity));
        heroQuantity.dispatchEvent(new Event('change', { bubbles: true }));
      }

      function syncHeroToSticky() {
        var safeQuantity = writeQuantity(stickyQuantity, readQuantity(heroQuantity));
        updatePurchaseTotal(action, safeQuantity);
      }

      writeQuantity(stickyQuantity, readQuantity(heroQuantity));
      stickyQuantity.addEventListener('input', syncStickyToHero);
      stickyQuantity.addEventListener('change', syncStickyToHero);
      heroQuantity.addEventListener('input', syncHeroToSticky);
      heroQuantity.addEventListener('change', syncHeroToSticky);
    }

    action.addEventListener('click', function () {
      if (action.classList.contains('is-adding')) return;
      if (stickyQuantity && heroQuantity) {
        writeQuantity(heroQuantity, readQuantity(stickyQuantity));
        heroQuantity.dispatchEvent(new Event('change', { bubbles: true }));
      }
      var timesactAction = activePreorderButton(heroForm) || heroForm.querySelector('.timesact-backInStock-button');
      (timesactAction || heroAction).click();
    });
  }

  function initGlowClubLinks() {
    document.querySelectorAll('.pdp-v2-glow').forEach(function (container) {
      function repairLinks() {
        container.querySelectorAll('a').forEach(function (link) {
          var href = link.getAttribute('href');
          if (!href || href === '#') link.setAttribute('href', '/pages/loyalty-program');
        });
      }

      repairLinks();
      if ('MutationObserver' in window) {
        var observer = new MutationObserver(repairLinks);
        observer.observe(container, {
          childList: true,
          subtree: true,
          attributes: true,
          attributeFilter: ['href']
        });
      }
    });
  }

  function init() {
    initQuantityControls();
    document.querySelectorAll('[data-pdp-v2-gallery]').forEach(initGallery);
    document.querySelectorAll('[data-pdp-v2-purchase]').forEach(initQuantity);
    document.querySelectorAll('[data-pdp-v2-product-form]').forEach(initProductForm);
    document.querySelectorAll('[data-pdp-v2-substitute-form]').forEach(initSubstituteForm);
    document.querySelectorAll('[data-pdp-v2-sticky]').forEach(initSticky);
    initGlowClubLinks();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();


